import { render, staticRenderFns } from "./custom-upload-file.vue?vue&type=template&id=702b98c4&"
import script from "./custom-upload-file.vue?vue&type=script&lang=js&"
export * from "./custom-upload-file.vue?vue&type=script&lang=js&"
import style0 from "./custom-upload-file.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports